export default __webpack_public_path__ + "static/media/drag.c156fd9f.svg";